import React from 'react';
import PropTypes from 'prop-types';
import EllipseMenuButton from './EllipseMenuButton';

export default {
  title: 'Components/EllipseMenuButton',
  component: EllipseMenuButton,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],

};

// Base Template function for stories
const MenuButtonTemplate = ({
  items,
}) => {
  return (<EllipseMenuButton items={items} />);
};

MenuButtonTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })).isRequired,
};

const Template = MenuButtonTemplate.bind({});

// Story

export const Default = Template.bind({});
Default.args = {
  items: [
    {
      label: 'Option1',
      onClick: () => {},
    },
    {
      label: 'Option2',
      onClick: () => {},
    },
  ],
};
